// extracted by mini-css-extract-plugin
export default {"dropDown":"dropdownIndicator-module__dropDown__SKZxo"};